/* This file is auto-generated, manual edits in this file will be overwritten! */
const SHADOWS = {
    AddNew: { value: '0.00px 4.00px 12.00px rgba(0, 0, 0, 0.20)' },
    Elevation: {
        Dark: {
            Bottom: {
                T01: {
                    value: '0.00px 1.00px 2.00px rgba(0, 0, 0, 0.32),0.00px 0.00px 1.00px rgba(40, 41, 61, 0.08)',
                },
                T02: {
                    value: '0.00px 2.00px 4.00px rgba(0, 0, 0, 0.32),0.00px 0.00px 1.00px rgba(0, 0, 0, 0.04)',
                },
                T03: {
                    value: '0.00px 4.00px 8.00px rgba(0, 0, 0, 0.32),0.00px 0.00px 2.00px rgba(0, 0, 0, 0.04)',
                },
                T04: {
                    value: '0.00px 8.00px 16.00px rgba(0, 0, 0, 0.32),0.00px 2.00px 4.00px rgba(0, 0, 0, 0.04)',
                },
                T05: {
                    value: '0.00px 16.00px 24.00px rgba(0, 0, 0, 0.32),0.00px 2.00px 8.00px rgba(0, 0, 0, 0.04)',
                },
            },
            Top: {
                T01: {
                    value: '0.00px -1.00px 2.00px rgba(0, 0, 0, 0.32),0.00px 0.00px 1.00px rgba(40, 41, 61, 0.08)',
                },
                T02: {
                    value: '0.00px -2.00px 4.00px rgba(0, 0, 0, 0.32),0.00px 0.00px 1.00px rgba(0, 0, 0, 0.04)',
                },
                T03: {
                    value: '0.00px -4.00px 8.00px rgba(0, 0, 0, 0.32),0.00px 0.00px 2.00px rgba(0, 0, 0, 0.04)',
                },
                T04: {
                    value: '0.00px -8.00px 16.00px rgba(0, 0, 0, 0.32),0.00px -2.00px 4.00px rgba(0, 0, 0, 0.04)',
                },
                T05: {
                    value: '0.00px -16.00px 24.00px rgba(0, 0, 0, 0.32),0.00px -2.00px 8.00px rgba(0, 0, 0, 0.04)',
                },
            },
        },
        Light: {
            Bottom: {
                T01: {
                    value: '0.00px 0.50px 2.00px rgba(96, 97, 112, 0.16),0.00px 0.00px 1.00px rgba(40, 41, 61, 0.08)',
                },
                T02: {
                    value: '0.00px 2.00px 4.00px rgba(96, 97, 112, 0.16),0.00px 0.00px 1.00px rgba(40, 41, 61, 0.04)',
                },
                T03: {
                    value: '0.00px 2.00px 4.00px rgba(96, 97, 112, 0.16),0.00px 0.00px 1.00px rgba(40, 41, 61, 0.04)',
                },
                T04: {
                    value: '0.00px 8.00px 16.00px rgba(96, 97, 112, 0.16),0.00px 2.00px 4.00px rgba(40, 41, 61, 0.04)',
                },
                T05: {
                    value: '0.00px 26.00px 34.00px rgba(96, 97, 112, 0.06),0.00px 2.00px 8.00px rgba(40, 41, 61, 0.04)',
                },
            },
            Top: {
                T01: {
                    value: '0.00px -0.50px 2.00px rgba(96, 97, 112, 0.16),0.00px 0.00px 1.00px rgba(40, 41, 61, 0.08)',
                },
                T02: {
                    value: '0.00px -2.00px 4.00px rgba(96, 97, 112, 0.16),0.00px 0.00px 1.00px rgba(40, 41, 61, 0.04)',
                },
                T03: {
                    value: '0.00px -4.00px 8.00px rgba(96, 97, 112, 0.16),0.00px 0.00px 2.00px rgba(40, 41, 61, 0.04)',
                },
                T04: {
                    value: '0.00px -8.00px 26.00px rgba(96, 97, 112, 0.06),0.00px -2.00px 14.00px rgba(40, 41, 61, 0.04)',
                },
                T05: {
                    value: '0.00px -16.00px 24.00px rgba(96, 97, 112, 0.16),0.00px -2.00px 8.00px rgba(40, 41, 61, 0.04)',
                },
            },
        },
    },
    Shadow: {
        Input: { value: '0.00px 4.00px 8.00px rgba(0, 0, 0, 0.02)' },
    },
    Sidebar: { value: '4.00px 1.00px 84.00px rgba(0, 0, 0, 0.12)' },
    Tabbar: { value: '0.00px -4.00px 32.00px rgba(0, 0, 0, 0.06)' },
};
export default SHADOWS;
